<template>
    <div class="initiatives-side-scroll fill-height">
      <div class="article-list mb-16">
        <div v-for="(project, index) in projects" :key="index" :class="[{'even': index % 2 === 0}, {'odd': index % 2 !== 0}, 'article mb-16']">
          <div>
            <span class="projectIndex d-none d-sm-block">{{`0${index+1}`}}</span>
            <seo-v-img
              cover
              class="image"
              :position="project.image_crop_position || 'center'"
              :max-width="$vuetify.breakpoint.smAndUp ? '100%' : '100%'"
              width="373"
              :aspect-ratio="1"
              :src="`/media/${project.image.id}`"
              :lazy-src="JSON.parse(project.image.metaData)['image-lazy-src']"
              >
              <div class="image-dark-cover" />
            </seo-v-img>
            <span class="projectName mt-8 pl-0 pl-sm-10"> {{project.name}}</span>
            <!--<h3 class="mt-8 mb-8" v-html="Splitting.html({content: project[`${$language.current}Title`], by: 'chars'})"></h3>-->
            <h3 class="mt-4 mb-2 pl-0 pl-sm-10" v-html="Splitting.html({content: project.name, by: 'chars'})"></h3>
          </div>
          <DiscoverButton  :to="{name: 'InitiativesDetails', params: {slug: project._slug} }" class="discover" />
          <!-- v-if="project.articles.length > 1 || project.articles.length === 0"
          <DiscoverButton v-else-if="project.articles.length === 1" :to="{ name: 'InitiativesArticle', params: { slug: project.articles[0]._slug, articleList: project.articles, projectSlug: project._slug } }" class="discover" />-->
        </div>
      </div>
    </div>
</template>

<script>
import DiscoverButton from '@/atoms/DiscoverButton'
import Splitting from 'splitting'

export default {
  name: 'InitiativesSideScroll',
  components: {
    DiscoverButton
  },
  props: {
    projects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      Splitting
    }
  }
}
</script>

<style scoped lang="scss">
  .initiatives-side-scroll {
    position: relative;
    z-index: 30;
    background-color: #131313;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .article-list {
      padding-left: 96px;
      padding-right: 96px;
      padding-top: 100px;
      overflow-y: scroll;
      overflow-x: hidden;
      height: 100%;
      width: 100%;
      position: relative;
      top: 0;
      bottom: 0;
      right: -17px;
      -webkit-overflow-scrolling: touch;

      @include breakpoint('xs-only') {
        padding-left: 0;
        padding-right: 33px;
      }
    }
  }

  .article {
    position: relative;
    min-height: 350px;

    &:last-child {
      @include breakpoint('xs-only') {
        margin-bottom: 180px !important;
      }
    }

    h3 {
      position: relative;
      z-index: 10;
      max-width: 55%;
      font-size: 2.7rem;
      color: #f8f8f8;
      @include breakpoint('xs-only') {
        font-size: 38px;
        max-width: 100%;
      }
    }

    .image {
      position: absolute;
      top: 10px;
      right: 0;
      z-index: -1;
      @include breakpoint('xs-only') {
        position: relative;
        width: 100%;
      }
    }

    .discover {
      color: $c-pink;
      padding-left: 10px !important;
      @include breakpoint('xs-only') {
        position: relative;
        left: auto;
        bottom: auto;

        /* stylelint-disable */
        ::v-deep .v-btn__content {
          padding-left: 0;
        }
        /* stylelint-enable */
      }
    }

    span.projectIndex {
      color: $c-pink;
      font-size: 1.5rem;
      font-family: $body-font-family;
      margin: 0;
      padding-top: 0;
      line-height: 1;
      z-index: 100;
    }

    span.projectName {
      font-family: $body-font-family;
      color: $c-pink;
      font-size: $font-size-root;
      display: block;
      z-index: 100;
    }

    &.odd {
      .image {
        left: 0;
        right: initial;
      }

      span.projectName {
        position: relative;
        left: 48%;
        z-index: 10;
        @include breakpoint('xs-only') {
          left: 0;
        }
      }

      span.projectIndex {
        position: relative;
        left: 45%;
      }

      h3 {
        position: relative;
        left: 48%;
        @include breakpoint('xs-only') {
          left: 0;
        }
      }

      .discover {
        left: 50%;
        padding-left: 0 !important;

        @include breakpoint('xs-only') {
          left: 0;

          /* stylelint-disable */
          ::v-deep .v-btn__content {
            padding-left: 0;
          }
          /* stylelint-enable */
        }
      }
    }
  }

</style>
